export const progressSx = { with: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' };

export const countSx = { display: 'inline', fontWeight: 700 };